import { render } from "./BasicCardAction.vue?vue&type=template&id=65873c3a&ts=true"
import script from "./BasicCardAction.vue?vue&type=script&lang=ts"
export * from "./BasicCardAction.vue?vue&type=script&lang=ts"

import "./BasicCardAction.vue?vue&type=style&index=0&id=65873c3a&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__